import { render, staticRenderFns } from "./AvatarWithFrame.vue?vue&type=template&id=b673de20&scoped=true"
import script from "./AvatarWithFrame.vue?vue&type=script&lang=js"
export * from "./AvatarWithFrame.vue?vue&type=script&lang=js"
import style0 from "./AvatarWithFrame.vue?vue&type=style&index=0&id=b673de20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b673de20",
  null
  
)

export default component.exports